import React from 'react'
import TitleComponent from '../../../../global/Custom/TitleComponent/TitleComponent'

import { useTranslation } from 'react-i18next'
import DataCategoryEditScreen from './CategoryEditScreen'

function DataCategoryEdit() {
  const {t} = useTranslation()

  return (
    <div>
        <TitleComponent title={t('Chỉnh sửa chi tiết danh mục')} isExist={false} />
        <DataCategoryEditScreen/>
    </div>
  )
}

export default DataCategoryEdit
